// DS: CO0.3, CO0.3M
import React, { useContext } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import Padlock from '@wix/da-ds/pkg/Illustrations/Padlock';
import ClockIcon from '@wix/da-ds/pkg/Icons/24x24/Clock';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import CoreSymbol from '@wix/da-ds/pkg/Indicators/CoreSymbol';
import { formatDate, DATE_FORMATS } from '@wix/da-ds/pkg/Time/functions';
import FragmentsValue from '../../FragmentsValue';
import BadgeIcon from './BadgeIcon';
import s from './BadgeCard.scss';
/** A selection button for a core badge awardable to another user */ const BadgeCard = ({ className, badge, biData, showLock, selected, onClick })=>{
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const { campaignEnd: expirationDate, giveLabel } = badge.badge;
    const formattedExpiration = formatDate(badge.badge.campaignEnd || '', isMobile ? DATE_FORMATS.Date.DayMonth : DATE_FORMATS.Date.DayLongMonth);
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        className: c(s['root'], selected && s['selected'], badge.disabled && s['disabled'], className),
        role: "radio",
        "aria-checked": selected,
        biData: biData,
        onClick: onClick
    }, expirationDate && /*#__PURE__*/ React.createElement("div", {
        className: s['special-edition-label']
    }, t('coreBadge.badgeCard.specialEdition')), !isMobile && expirationDate && !badge.disabled && /*#__PURE__*/ React.createElement("div", {
        className: s['expiration-date']
    }, /*#__PURE__*/ React.createElement(ClockIcon, {
        className: s['expires-clock']
    }), ' ', t('coreBadge.badgeCard.expires'), ' ', /*#__PURE__*/ React.createElement("time", {
        "aria-label": formattedExpiration,
        dateTime: expirationDate,
        suppressHydrationWarning: true
    }, formattedExpiration)), badge.disabled && /*#__PURE__*/ React.createElement("div", {
        className: s['disabled-label']
    }, t('coreBadge.badgeCard.awarded')), isMobile && !!badge.core && /*#__PURE__*/ React.createElement("div", {
        className: s['badge-label']
    }, isMobile ? t('coreBadge.badgeCard.awardCoreMembership.mobile', {
        postProcess: [
            'reactPostprocessor',
            'featureBrancher'
        ],
        coreSymbol: /*#__PURE__*/ React.createElement(CoreSymbol, {
            corePackage: "generic",
            className: s['core-label-icon'],
            customSize: {
                width: 12,
                height: 12
            }
        }),
        core: /*#__PURE__*/ React.createElement("div", {
            className: s['core-label']
        }, "Core")
    }) : t('coreBadge.badgeCard.awardCoreMembership')), /*#__PURE__*/ React.createElement(BadgeIcon, {
        badge: badge.badge,
        className: s['badge-icon']
    }), /*#__PURE__*/ React.createElement(Heading, {
        className: s['badge-title']
    }, badge.badge.baseTitle), !isMobile && !badge.canGiveCore && /*#__PURE__*/ React.createElement("div", {
        className: s['badge-label']
    }, giveLabel), !isMobile && badge.canGiveCore && /*#__PURE__*/ React.createElement("div", {
        className: s['badge-label']
    }, t('coreBadge.badgeCard.awardCoreMembership.v2', {
        postProcess: [
            'reactPostprocessor',
            'featureBrancher'
        ],
        coreSymbol: /*#__PURE__*/ React.createElement(CoreSymbol, {
            corePackage: "generic",
            className: s['core-label-icon'],
            customSize: {
                width: 12,
                height: 12
            }
        }),
        core: /*#__PURE__*/ React.createElement("div", {
            className: s['core-label']
        }, "Core")
    })), showLock && /*#__PURE__*/ React.createElement("div", {
        className: s['lock-icon']
    }, /*#__PURE__*/ React.createElement(Padlock, null)), /*#__PURE__*/ React.createElement("div", {
        className: s['fragments-needed']
    }, /*#__PURE__*/ React.createElement(FragmentsValue, {
        amount: badge.price,
        className: s['fragments-value']
    }), /*#__PURE__*/ React.createElement("span", {
        className: s['fragments-unit']
    }, t('coreBadge.badgeCard.fragments'))), isMobile && expirationDate && /*#__PURE__*/ React.createElement("div", {
        className: s['expiration-date']
    }, /*#__PURE__*/ React.createElement(ClockIcon, {
        className: s['expires-clock']
    }), ' ', t('coreBadge.badgeCard.expires'), ' ', /*#__PURE__*/ React.createElement("time", {
        "aria-label": formattedExpiration,
        dateTime: expirationDate,
        suppressHydrationWarning: true
    }, formattedExpiration)));
};
BadgeCard.displayName = 'BadgeCard';
export default BadgeCard;

//# sourceMappingURL=BadgeCard.js.map